import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { InlineLabel } from '@dealstack/frontend/shared/components/fundament/InlineLabel/InlineLabel';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { ISubItemProps } from '@dealstack/shared/lib/frontend/common-ui/forms';
import { BaseSyntheticEvent, memo } from 'react';
import styled, { css } from 'styled-components';
import { IInlineLabelProps } from '@dealstack/frontend/shared/components/fundament/InlineLabel/InlineLabel.types';

export interface Props extends ISubItemProps, IInlineLabelProps {
	className?: string;
	checked?: boolean;
	onClick?: (event: BaseSyntheticEvent) => unknown;
	iconSize?: string;
	/** Index for E2E testing - used as data-testindex attribute */
	index?: number;
}

const Checkbox = ({
	className,
	label,
	labelPlacement,
	checked,
	disabled,
	bold,
	onClick,
	index,
}: Props) => {
	return (
		<div className={`${className}`} onClick={disabled ? undefined : onClick}>
			<UIElementIdentifier identifier={TEST_ELEMENT_IDS.TABLE_CHECKBOX} index={index}>
				<InlineLabel
					disabled={disabled}
					label={label}
					labelPlacement={labelPlacement}
					bold={bold}
				>
					<Icon variant={checked ? 'checkbox-checked' : 'checkbox-unchecked'} />
				</InlineLabel>
			</UIElementIdentifier>
		</div>
	);
};

const Memoized = memo(Checkbox);
const Styled = styled(Memoized)`
	display: flex;
	cursor: pointer;
	justify-content: flex-start;
	align-items: center;
	border-radius: 4px;
	padding: 0.25rem;

	${Icon}.svg {
		--size: ${({ iconSize }) => iconSize ?? `1rem`};
		width: var(--size);
		height: var(--size);
		color: ${({ checked, theme }) =>
			checked ? theme.v2.color.secondary[800] : theme.v2.color.neutral[600]};
		flex-shrink: 0;
	}

	${Text} {
		margin-left: 0.75rem;
	}

	${({ theme, disabled }) =>
		disabled
			? css`
					cursor: not-allowed !important;
					${Icon}.svg {
						color: ${theme.v2.color.neutral[400]};
					}
				`
			: css`
					&:hover {
						background-color: ${({ theme }) => theme.v2.color.secondary[200]};
					}
				`}
`;

export { Styled as Checkbox };
